import type { FaseOS } from '../types';

export const getFasesOrdenadas = (fases: FaseOS[]): FaseOS[] =>
  [...fases].sort((a, b) => a.ordem - b.ordem);

export const getFaseAnteriorPendente = (
  fase: FaseOS,
  fases: FaseOS[]
): FaseOS | null => {
  const ordenadas = getFasesOrdenadas(fases);
  const index = ordenadas.findIndex((f) => f.id === fase.id);
  if (index <= 0) return null;

  for (let i = 0; i < index; i += 1) {
    if (ordenadas[i].status_fase !== 'Concluída') {
      return ordenadas[i];
    }
  }

  return null;
};

export const podeIniciarFase = (fase: FaseOS, fases: FaseOS[]): boolean => {
  if (fase.status_fase !== 'Pendente') return false;
  return getFaseAnteriorPendente(fase, fases) === null;
};

export const getMensagemBloqueioInicio = (
  fase: FaseOS,
  fases: FaseOS[]
): string | null => {
  if (fase.status_fase !== 'Pendente') return null;

  const bloqueadora = getFaseAnteriorPendente(fase, fases);
  if (!bloqueadora) return null;

  return `Finalize "${bloqueadora.nome_fase}" antes de iniciar "${fase.nome_fase}".`;
};

export const podeCancelarFase = (fase: FaseOS): boolean =>
  fase.status_fase === 'Em Rota';

export const podeFinalizarFase = (fase: FaseOS): boolean =>
  fase.status_fase === 'Em Rota';

export const isSepultamentoMesmoLocalInformativo = (
  fase: FaseOS,
  ordemServico: { velorio_sepultamento_mesmo_local?: boolean }
): boolean =>
  Boolean(
    ordemServico.velorio_sepultamento_mesmo_local && fase.nome_fase === 'Sepultamento'
  );
